export default __webpack_public_path__ + "static/media/icon-view.0c11cc23.svg";